import script from "./ArtworkSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtworkSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ArtworkSkeleton.vue?vue&type=style&index=0&id=8af267ac&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\artware\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8af267ac"]])

export default __exports__